export default window._cmsContent['solar/register-interest']